var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "inner-card", style: { background: _vm.backgroundColor } },
    [
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "enforce-focus": false,
          loader: "dots",
        },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("ValidationObserver", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ handleSubmit }) {
              return [
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("div", { staticClass: "col-md-6" }, [
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("ValidationProvider", {
                            staticClass: "w-100",
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "field-title" },
                                        [
                                          _c("span", { staticClass: "mark" }, [
                                            _vm._v("*"),
                                          ]),
                                          _c(
                                            "span",
                                            { style: { color: _vm.fontColor } },
                                            [
                                              _vm._v(" 是否有工作經驗？ "),
                                              _c(
                                                "span",
                                                { staticClass: "en-text" },
                                                [
                                                  _vm._v(
                                                    "Have any work experience?"
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-radio" },
                                        [
                                          _c("label", [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.hasExperience,
                                                  expression: "hasExperience",
                                                },
                                              ],
                                              attrs: { type: "radio" },
                                              domProps: {
                                                value: true,
                                                checked: _vm._q(
                                                  _vm.hasExperience,
                                                  true
                                                ),
                                              },
                                              on: {
                                                change: function ($event) {
                                                  _vm.hasExperience = true
                                                },
                                              },
                                            }),
                                            _c("span", [_vm._v("是 (Yes)")]),
                                          ]),
                                          _c("label", [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.hasExperience,
                                                  expression: "hasExperience",
                                                },
                                              ],
                                              attrs: { type: "radio" },
                                              domProps: {
                                                value: false,
                                                checked: _vm._q(
                                                  _vm.hasExperience,
                                                  false
                                                ),
                                              },
                                              on: {
                                                change: function ($event) {
                                                  _vm.hasExperience = false
                                                },
                                              },
                                            }),
                                            _c("span", [_vm._v("否 (No)")]),
                                          ]),
                                        ]
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "col-md-6" }),
                    _vm._l(_vm.workExperience, function (item, index) {
                      return [
                        _c(
                          "div",
                          { key: "Company" + index, staticClass: "col-md-6" },
                          [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("ValidationProvider", {
                                  attrs: { rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "field-title" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "mark" },
                                                  [_vm._v("*")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color: _vm.fontColor,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(" 公司名稱 "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "en-text",
                                                      },
                                                      [_vm._v("Company name")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-value" },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: item.Company,
                                                      expression:
                                                        "item.Company",
                                                    },
                                                  ],
                                                  attrs: {
                                                    type: "text",
                                                    maxlength: "200",
                                                    autocomplete: "off",
                                                    readonly: "",
                                                  },
                                                  domProps: {
                                                    value: item.Company,
                                                  },
                                                  on: {
                                                    focus: function ($event) {
                                                      return _vm.$common.removeReadonly(
                                                        $event
                                                      )
                                                    },
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        item,
                                                        "Company",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                            errors[0]
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          { key: "Seniority" + index, staticClass: "col-md-6" },
                          [
                            _c("div", { staticClass: "field" }, [
                              _c("div", { staticClass: "field-title" }, [
                                _c(
                                  "span",
                                  { style: { color: _vm.fontColor } },
                                  [
                                    _vm._v(" 年資 "),
                                    _c("span", { staticClass: "en-text" }, [
                                      _vm._v("Seniority"),
                                    ]),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "field-value" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: item.Seniority,
                                      expression: "item.Seniority",
                                    },
                                  ],
                                  attrs: { type: "text", disabled: "" },
                                  domProps: { value: item.Seniority },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        item,
                                        "Seniority",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          { key: "Position" + index, staticClass: "col-md-6" },
                          [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("ValidationProvider", {
                                  attrs: { rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "field-title" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "mark" },
                                                  [_vm._v("*")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color: _vm.fontColor,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(" 職務 "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "en-text",
                                                      },
                                                      [_vm._v("Duties")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-value" },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: item.Position,
                                                      expression:
                                                        "item.Position",
                                                    },
                                                  ],
                                                  attrs: {
                                                    type: "text",
                                                    maxlength: "50",
                                                    autocomplete: "off",
                                                    readonly: "",
                                                  },
                                                  domProps: {
                                                    value: item.Position,
                                                  },
                                                  on: {
                                                    focus: function ($event) {
                                                      return _vm.$common.removeReadonly(
                                                        $event
                                                      )
                                                    },
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        item,
                                                        "Position",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                            errors[0]
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            key: "Department" + index,
                            staticClass: "col-md-6",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("ValidationProvider", {
                                  attrs: { rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "field-title" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "mark" },
                                                  [_vm._v("*")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color: _vm.fontColor,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(" 服務部門 "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "en-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Service department"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-value" },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: item.Department,
                                                      expression:
                                                        "item.Department",
                                                    },
                                                  ],
                                                  attrs: {
                                                    type: "text",
                                                    maxlength: "50",
                                                    autocomplete: "off",
                                                    readonly: "",
                                                  },
                                                  domProps: {
                                                    value: item.Department,
                                                  },
                                                  on: {
                                                    focus: function ($event) {
                                                      return _vm.$common.removeReadonly(
                                                        $event
                                                      )
                                                    },
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        item,
                                                        "Department",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                            errors[0]
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            key: "MonthlySalary" + index,
                            staticClass: "col-md-6",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("ValidationProvider", {
                                  staticClass: "w-100",
                                  attrs: {
                                    name: "每月薪資",
                                    rules: { regex: new RegExp(/^([0-9,]+)$/) },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "field-title" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color: _vm.fontColor,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(" 每月薪資 "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "en-text",
                                                      },
                                                      [_vm._v("Monthly salary")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-value" },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model.trim",
                                                      value: item.MonthlySalary,
                                                      expression:
                                                        "item.MonthlySalary",
                                                      modifiers: { trim: true },
                                                    },
                                                  ],
                                                  attrs: { type: "text" },
                                                  domProps: {
                                                    value: item.MonthlySalary,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        item,
                                                        "MonthlySalary",
                                                        $event.target.value.trim()
                                                      )
                                                    },
                                                    blur: function ($event) {
                                                      return _vm.$forceUpdate()
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                            errors
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          { key: "onTheJob" + index, staticClass: "col-md-6" },
                          [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("ValidationProvider", {
                                  attrs: { rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "field-title" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "mark" },
                                                  [_vm._v("*")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color: _vm.fontColor,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(" 是否仍在職？ "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "en-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Are still working?"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-radio" },
                                              [
                                                _c("label", [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: item.OnTheJob,
                                                        expression:
                                                          "item.OnTheJob",
                                                      },
                                                    ],
                                                    attrs: { type: "radio" },
                                                    domProps: {
                                                      value: true,
                                                      checked: _vm._q(
                                                        item.OnTheJob,
                                                        true
                                                      ),
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          item,
                                                          "OnTheJob",
                                                          true
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _c("span", [
                                                    _vm._v("是 (Yes)"),
                                                  ]),
                                                ]),
                                                _c("label", [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: item.OnTheJob,
                                                        expression:
                                                          "item.OnTheJob",
                                                      },
                                                    ],
                                                    attrs: { type: "radio" },
                                                    domProps: {
                                                      value: false,
                                                      checked: _vm._q(
                                                        item.OnTheJob,
                                                        false
                                                      ),
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          item,
                                                          "OnTheJob",
                                                          false
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _c("span", [
                                                    _vm._v("否 (No)"),
                                                  ]),
                                                ]),
                                              ]
                                            ),
                                            errors[0]
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            key: "LeaveReason" + index,
                            staticClass: "col-md-12",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("ValidationProvider", {
                                  attrs: { rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "field-title" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "mark" },
                                                  [_vm._v("*")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color: _vm.fontColor,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(" (欲)離職原因 "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "en-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Reason for resignation"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-value" },
                                              [
                                                _c("el-input", {
                                                  staticClass: "w-100",
                                                  attrs: {
                                                    type: "textarea",
                                                    rows: 4,
                                                    maxlength: "10000",
                                                    "show-word-limit": "",
                                                  },
                                                  model: {
                                                    value: item.LeaveReason,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "LeaveReason",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item.LeaveReason",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            errors[0]
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            key: "ExperienceFrom" + index,
                            staticClass: "col-md-3",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("ValidationProvider", {
                                  attrs: { rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "field-title" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "mark" },
                                                  [_vm._v("*")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color: _vm.fontColor,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(" 工作起始年月 "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "en-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Service period (Start)"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-value" },
                                              [
                                                _c("el-date-picker", {
                                                  staticClass: "w-100",
                                                  attrs: {
                                                    type: "month",
                                                    "value-format": "yyyy-MM",
                                                    "picker-options": {
                                                      disabledDate:
                                                        _vm.$common
                                                          .disabledDateAfterToday,
                                                    },
                                                    placeholder: "YYYY-MM",
                                                  },
                                                  model: {
                                                    value: item.ExperienceFrom,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "ExperienceFrom",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item.ExperienceFrom",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            errors[0]
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            key: "ExperienceTo" + index,
                            staticClass: "col-md-3",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("ValidationProvider", {
                                  attrs: {
                                    rules: {
                                      required: !item.OnTheJob ? true : false,
                                      notBeforeStartDate: !item.OnTheJob
                                        ? item.ExperienceFrom
                                        : false,
                                    },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "field-title" },
                                              [
                                                !item.OnTheJob
                                                  ? _c(
                                                      "span",
                                                      { staticClass: "mark" },
                                                      [_vm._v("*")]
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color: _vm.fontColor,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(" 工作終止年月 "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "en-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Service period (End)"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-value" },
                                              [
                                                _c("el-date-picker", {
                                                  staticClass: "w-100",
                                                  attrs: {
                                                    type: "month",
                                                    "value-format": "yyyy-MM",
                                                    disabled: item.OnTheJob,
                                                    placeholder: "YYYY-MM",
                                                  },
                                                  model: {
                                                    value: item.ExperienceTo,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "ExperienceTo",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item.ExperienceTo",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            errors[0]
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm.workExperience.length > 1
                          ? _c(
                              "div",
                              {
                                key: "button" + index,
                                staticClass: "col-md-6",
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "del-btn",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.del(index)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("BUTTON.RESUME_DELETE")) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    }),
                  ],
                  2
                ),
                _c("div", { staticClass: "edit-btn-wrap" }, [
                  _vm.hasExperience
                    ? _c(
                        "button",
                        {
                          staticClass: "btn-sm add-btn",
                          attrs: { type: "button" },
                          on: { click: _vm.add },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("BUTTON.RESUME_ADD")) + " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "button",
                    {
                      staticClass: "put-btn",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return handleSubmit(_vm.saveWorkExperience)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("BUTTON.RESUME_SAVE")) + " ")]
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }